import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// SEC-005 — auth tokens are stored in httpOnly cookies (not localStorage) to
// close the XSS token-theft vector. withCredentials sends the cookie on every
// request; the browser will never expose the token value to JS.
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401) {
      // Session missing/expired — drop cached user and bounce to landing.
      try { localStorage.removeItem("hv_user"); } catch { /* storage disabled */ }
      if (!["/", "/login", "/admin/login"].includes(window.location.pathname) && !window.location.pathname.startsWith("/share/")) {
        window.location.href = "/";
      }
    }
    if (e?.response?.status === 402) {
      // Pro-only feature blocked. Toast on the next tick to avoid double-mounting issues.
      try {
        import("sonner").then(({ toast }) => {
          toast.error(e?.response?.data?.detail || "Upgrade required", {
            description: "This feature is part of Verda Pro.",
            action: { label: "Upgrade", onClick: () => { window.location.href = "/subscription"; } },
          });
        });
      } catch (importErr) {
        // Toast library failed to load — swallow (this branch is only hit if bundling breaks)
        return Promise.reject(importErr);
      }
    }
    return Promise.reject(e);
  }
);
